
import type { ColorMap } from "./types";

export const sargassum: ColorMap = {
  r: [0.3843137254901961, 0.38823529411764707, 0.396078431372549, 0.4, 0.40784313725490196, 0.41568627450980394, 0.42745098039215684, 0.43529411764705883, 0.44313725490196076, 0.4549019607843137, 0.4666666666666667, 0.4745098039215686, 0.48627450980392156, 0.49411764705882355, 0.5058823529411764, 0.5137254901960784, 0.5254901960784314, 0.5333333333333333, 0.5450980392156862, 0.5529411764705883, 0.5647058823529412, 0.5725490196078431, 0.5843137254901961, 0.592156862745098, 0.6039215686274509, 0.615686274509804, 0.6235294117647059, 0.6352941176470588, 0.6431372549019608, 0.6549019607843137, 0.6627450980392157, 0.6745098039215687, 0.6823529411764706, 0.6901960784313725, 0.7019607843137254, 0.7098039215686275, 0.7215686274509804, 0.7294117647058823, 0.7372549019607844, 0.7490196078431373, 0.7568627450980392, 0.7686274509803922, 0.7764705882352941, 0.788235294117647, 0.796078431372549, 0.803921568627451, 0.8156862745098039, 0.8235294117647058, 0.8313725490196079, 0.8392156862745098, 0.8470588235294118, 0.8509803921568627, 0.8588235294117647, 0.8627450980392157, 0.8666666666666667, 0.8705882352941177, 0.8705882352941177, 0.8745098039215686, 0.8784313725490196, 0.8784313725490196, 0.8823529411764706, 0.8862745098039215, 0.8862745098039215, 0.8901960784313725, 0.8941176470588236, 0.8980392156862745, 0.8980392156862745, 0.9019607843137255, 0.9058823529411765, 0.9058823529411765, 0.9098039215686274, 0.9098039215686274, 0.9137254901960784, 0.9176470588235294, 0.9176470588235294, 0.9215686274509803, 0.9254901960784314, 0.9254901960784314, 0.9294117647058824, 0.9333333333333333, 0.9372549019607843, 0.9411764705882353, 0.9411764705882353, 0.9450980392156862, 0.9490196078431372, 0.9490196078431372, 0.9529411764705882, 0.9529411764705882, 0.9568627450980393, 0.9607843137254902, 0.9607843137254902, 0.9647058823529412, 0.9686274509803922, 0.9686274509803922, 0.9725490196078431, 0.9725490196078431, 0.9764705882352941, 0.9764705882352941, 0.9803921568627451, 0.984313725490196, 0.984313725490196, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9921568627450981, 0.9921568627450981, 0.9921568627450981, 0.9921568627450981, 0.9921568627450981, 0.9921568627450981, 0.9921568627450981, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.984313725490196, 0.984313725490196, 0.984313725490196, 0.984313725490196, 0.9803921568627451, 0.9803921568627451, 0.9803921568627451, 0.9803921568627451, 0.9764705882352941, 0.9764705882352941, 0.9764705882352941, 0.9764705882352941, 0.9764705882352941, 0.9764705882352941, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9725490196078431, 0.9686274509803922, 0.9686274509803922, 0.9647058823529412, 0.9647058823529412, 0.9607843137254902, 0.9529411764705882, 0.9490196078431372, 0.9411764705882353, 0.9333333333333333, 0.9254901960784314, 0.9137254901960784, 0.9058823529411765, 0.8941176470588236, 0.8862745098039215, 0.8745098039215686, 0.8666666666666667, 0.8549019607843137, 0.8470588235294118, 0.8392156862745098, 0.8274509803921568, 0.8196078431372549, 0.807843137254902, 0.8, 0.788235294117647, 0.7803921568627451, 0.7686274509803922, 0.7568627450980392, 0.7450980392156863, 0.7372549019607844, 0.7254901960784313, 0.7137254901960784, 0.7058823529411765, 0.6941176470588235, 0.6823529411764706, 0.6745098039215687, 0.6627450980392157, 0.6509803921568628, 0.6392156862745098, 0.6313725490196078, 0.6196078431372549, 0.6078431372549019, 0.6, 0.5882352941176471, 0.5764705882352941, 0.5686274509803921, 0.5568627450980392, 0.5450980392156862, 0.5333333333333333, 0.5215686274509804, 0.5098039215686274, 0.5019607843137255, 0.49019607843137253, 0.4823529411764706, 0.4745098039215686, 0.47058823529411764, 0.47058823529411764, 0.47058823529411764, 0.4745098039215686, 0.47843137254901963, 0.48627450980392156, 0.49411764705882355, 0.5019607843137255, 0.5137254901960784, 0.5254901960784314, 0.5372549019607843, 0.5450980392156862, 0.5568627450980392, 0.5686274509803921, 0.5803921568627451, 0.592156862745098, 0.6039215686274509, 0.615686274509804, 0.6235294117647059, 0.6352941176470588, 0.6470588235294118, 0.6588235294117647, 0.6705882352941176, 0.6823529411764706, 0.6941176470588235, 0.7058823529411765, 0.7137254901960784, 0.7254901960784313, 0.7372549019607844, 0.7490196078431373, 0.7607843137254902, 0.7725490196078432, 0.7843137254901961, 0.792156862745098, 0.803921568627451, 0.8156862745098039, 0.8235294117647058, 0.8352941176470589, 0.8470588235294118, 0.8549019607843137, 0.8666666666666667, 0.8784313725490196, 0.8901960784313725, 0.8980392156862745, 0.9098039215686274, 0.9215686274509803, 0.9294117647058824, 0.9411764705882353, 0.9490196078431372, 0.9568627450980393, 0.9647058823529412, 0.9686274509803922, 0.9725490196078431, 0.9725490196078431],
  g: [0.07058823529411765, 0.07058823529411765, 0.07450980392156863, 0.0784313725490196, 0.08235294117647059, 0.08627450980392157, 0.09019607843137255, 0.09411764705882353, 0.10196078431372549, 0.10588235294117647, 0.11372549019607843, 0.11764705882352941, 0.12549019607843137, 0.13333333333333333, 0.13725490196078433, 0.1450980392156863, 0.14901960784313725, 0.1568627450980392, 0.1607843137254902, 0.16470588235294117, 0.17254901960784313, 0.17647058823529413, 0.1843137254901961, 0.18823529411764706, 0.19607843137254902, 0.2, 0.20784313725490197, 0.21176470588235294, 0.21568627450980393, 0.2235294117647059, 0.22745098039215686, 0.23529411764705882, 0.23921568627450981, 0.24705882352941178, 0.25098039215686274, 0.25882352941176473, 0.2627450980392157, 0.26666666666666666, 0.27450980392156865, 0.2784313725490196, 0.2823529411764706, 0.28627450980392155, 0.29411764705882354, 0.2980392156862745, 0.30196078431372547, 0.30980392156862746, 0.3137254901960784, 0.3176470588235294, 0.3254901960784314, 0.32941176470588235, 0.33725490196078434, 0.3411764705882353, 0.34901960784313724, 0.35294117647058826, 0.3607843137254902, 0.36470588235294116, 0.3686274509803922, 0.3764705882352941, 0.3803921568627451, 0.38823529411764707, 0.39215686274509803, 0.4, 0.403921568627451, 0.4117647058823529, 0.41568627450980394, 0.4235294117647059, 0.42745098039215684, 0.43529411764705883, 0.4392156862745098, 0.4470588235294118, 0.45098039215686275, 0.4588235294117647, 0.4627450980392157, 0.47058823529411764, 0.4745098039215686, 0.47843137254901963, 0.48627450980392156, 0.49019607843137253, 0.49411764705882355, 0.5019607843137255, 0.5058823529411764, 0.5137254901960784, 0.5176470588235295, 0.5254901960784314, 0.5294117647058824, 0.5372549019607843, 0.5411764705882353, 0.5450980392156862, 0.5529411764705883, 0.5568627450980392, 0.5647058823529412, 0.5686274509803921, 0.5764705882352941, 0.5803921568627451, 0.5882352941176471, 0.592156862745098, 0.596078431372549, 0.6, 0.6078431372549019, 0.611764705882353, 0.615686274509804, 0.6196078431372549, 0.6235294117647059, 0.6274509803921569, 0.6313725490196078, 0.6352941176470588, 0.6392156862745098, 0.6392156862745098, 0.6431372549019608, 0.6470588235294118, 0.6470588235294118, 0.6509803921568628, 0.6509803921568628, 0.6509803921568628, 0.6549019607843137, 0.6549019607843137, 0.6588235294117647, 0.6588235294117647, 0.6627450980392157, 0.6627450980392157, 0.6666666666666666, 0.6666666666666666, 0.6705882352941176, 0.6705882352941176, 0.6745098039215687, 0.6784313725490196, 0.6784313725490196, 0.6823529411764706, 0.6862745098039216, 0.6862745098039216, 0.6901960784313725, 0.6901960784313725, 0.6941176470588235, 0.6941176470588235, 0.6980392156862745, 0.6980392156862745, 0.7019607843137254, 0.7019607843137254, 0.7019607843137254, 0.7058823529411765, 0.7058823529411765, 0.7098039215686275, 0.7098039215686275, 0.7137254901960784, 0.7137254901960784, 0.7176470588235294, 0.7215686274509804, 0.7215686274509804, 0.7254901960784313, 0.7254901960784313, 0.7294117647058823, 0.7294117647058823, 0.7333333333333333, 0.7333333333333333, 0.7333333333333333, 0.7333333333333333, 0.7333333333333333, 0.7294117647058823, 0.7294117647058823, 0.7294117647058823, 0.7294117647058823, 0.7294117647058823, 0.7294117647058823, 0.7254901960784313, 0.7254901960784313, 0.7254901960784313, 0.7254901960784313, 0.7215686274509804, 0.7215686274509804, 0.7215686274509804, 0.7215686274509804, 0.7176470588235294, 0.7176470588235294, 0.7176470588235294, 0.7176470588235294, 0.7176470588235294, 0.7176470588235294, 0.7176470588235294, 0.7137254901960784, 0.7137254901960784, 0.7137254901960784, 0.7137254901960784, 0.7137254901960784, 0.7137254901960784, 0.7098039215686275, 0.7098039215686275, 0.7098039215686275, 0.7058823529411765, 0.7058823529411765, 0.7058823529411765, 0.7058823529411765, 0.7058823529411765, 0.7019607843137254, 0.7019607843137254, 0.7019607843137254, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.6980392156862745, 0.7019607843137254, 0.7019607843137254, 0.7058823529411765, 0.7098039215686275, 0.7137254901960784, 0.7176470588235294, 0.7215686274509804, 0.7294117647058823, 0.7372549019607844, 0.7411764705882353, 0.7490196078431373, 0.7529411764705882, 0.7607843137254902, 0.7647058823529411, 0.7725490196078432, 0.7803921568627451, 0.7843137254901961, 0.792156862745098, 0.8, 0.803921568627451, 0.8117647058823529, 0.8156862745098039, 0.8235294117647058, 0.8313725490196079, 0.8352941176470589, 0.8431372549019608, 0.8470588235294118, 0.8549019607843137, 0.8588235294117647, 0.8666666666666667, 0.8705882352941177, 0.8745098039215686, 0.8823529411764706, 0.8862745098039215, 0.8941176470588236, 0.8980392156862745, 0.9058823529411765, 0.9098039215686274, 0.9176470588235294, 0.9254901960784314, 0.9294117647058824, 0.9372549019607843, 0.9411764705882353, 0.9490196078431372, 0.9529411764705882, 0.9568627450980393, 0.9647058823529412, 0.9686274509803922, 0.9725490196078431, 0.9764705882352941, 0.9803921568627451, 0.9803921568627451, 0.9882352941176471],
  b: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.00392156862745098, 0.0, 0.0, 0.0, 0.0, 0.00392156862745098, 0.00392156862745098, 0.00784313725490196, 0.00784313725490196, 0.011764705882352941, 0.01568627450980392, 0.023529411764705882, 0.027450980392156862, 0.03137254901960784, 0.0392156862745098, 0.043137254901960784, 0.047058823529411764, 0.050980392156862744, 0.058823529411764705, 0.06274509803921569, 0.06666666666666667, 0.07058823529411765, 0.0784313725490196, 0.08235294117647059, 0.08627450980392157, 0.09019607843137255, 0.09411764705882353, 0.09803921568627451, 0.10196078431372549, 0.10588235294117647, 0.10980392156862745, 0.11372549019607843, 0.11764705882352941, 0.11764705882352941, 0.12156862745098039, 0.12156862745098039, 0.12549019607843137, 0.12549019607843137, 0.12941176470588237, 0.12941176470588237, 0.13333333333333333, 0.13333333333333333, 0.13333333333333333, 0.13725490196078433, 0.13725490196078433, 0.13725490196078433, 0.1411764705882353, 0.1411764705882353, 0.1411764705882353, 0.1450980392156863, 0.1450980392156863, 0.1450980392156863, 0.1450980392156863, 0.14901960784313725, 0.14901960784313725, 0.14901960784313725, 0.14901960784313725, 0.14901960784313725, 0.15294117647058825, 0.15294117647058825, 0.15294117647058825, 0.15294117647058825, 0.15294117647058825, 0.15294117647058825, 0.15294117647058825, 0.1568627450980392, 0.1568627450980392, 0.1568627450980392, 0.1568627450980392, 0.1568627450980392, 0.1568627450980392, 0.1607843137254902, 0.1607843137254902, 0.1607843137254902, 0.1607843137254902, 0.16470588235294117, 0.16470588235294117, 0.16470588235294117, 0.16470588235294117, 0.16862745098039217, 0.16862745098039217, 0.17254901960784313, 0.17647058823529413, 0.1803921568627451, 0.18823529411764706, 0.19607843137254902, 0.20392156862745098, 0.21568627450980393, 0.23137254901960785, 0.24705882352941178, 0.2627450980392157, 0.2784313725490196, 0.29411764705882354, 0.30980392156862746, 0.3254901960784314, 0.3411764705882353, 0.35294117647058826, 0.3686274509803922, 0.3843137254901961, 0.396078431372549, 0.4117647058823529, 0.4235294117647059, 0.4392156862745098, 0.45098039215686275, 0.4666666666666667, 0.47843137254901963, 0.49019607843137253, 0.5019607843137255, 0.5137254901960784, 0.5254901960784314, 0.5411764705882353, 0.5529411764705883, 0.5647058823529412, 0.5764705882352941, 0.5882352941176471, 0.6, 0.611764705882353, 0.6235294117647059, 0.6352941176470588, 0.6470588235294118, 0.6549019607843137, 0.6666666666666666, 0.6784313725490196, 0.6901960784313725, 0.7019607843137254, 0.7137254901960784, 0.7254901960784313, 0.7372549019607844, 0.7490196078431373, 0.7568627450980392, 0.7686274509803922, 0.7803921568627451, 0.788235294117647, 0.8, 0.807843137254902, 0.8196078431372549, 0.8274509803921568, 0.8313725490196079, 0.8392156862745098, 0.8431372549019608, 0.8470588235294118, 0.8509803921568627, 0.8549019607843137, 0.8588235294117647, 0.8627450980392157, 0.8666666666666667, 0.8705882352941177, 0.8745098039215686, 0.8784313725490196, 0.8784313725490196, 0.8823529411764706, 0.8862745098039215, 0.8862745098039215, 0.8901960784313725, 0.8941176470588236, 0.8980392156862745, 0.9019607843137255, 0.9058823529411765, 0.9098039215686274, 0.9137254901960784, 0.9137254901960784, 0.9176470588235294, 0.9215686274509803, 0.9254901960784314, 0.9254901960784314, 0.9294117647058824, 0.9333333333333333, 0.9333333333333333, 0.9372549019607843, 0.9411764705882353, 0.9450980392156862, 0.9490196078431372, 0.9529411764705882, 0.9529411764705882, 0.9568627450980393, 0.9607843137254902, 0.9647058823529412, 0.9647058823529412, 0.9686274509803922, 0.9725490196078431, 0.9764705882352941, 0.9803921568627451, 0.9803921568627451, 0.984313725490196, 0.9882352941176471, 0.9882352941176471, 0.9882352941176471, 0.9921568627450981, 0.9921568627450981],
};


export const sargassumColorRamp = {
  "type": "multipart",
  "colorRamps": [
    {
      "type": "algorithmic",
      "fromColor": [
        98,
        18,
        0,
        255
      ],
      "toColor": [
        124,
        32,
        1,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.0,
      "stop": 0.047619047619047616
    },
    {
      "type": "algorithmic",
      "fromColor": [
        124,
        32,
        1,
        255
      ],
      "toColor": [
        154,
        50,
        0,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.047619047619047616,
      "stop": 0.09523809523809523
    },
    {
      "type": "algorithmic",
      "fromColor": [
        154,
        50,
        0,
        255
      ],
      "toColor": [
        184,
        67,
        0,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.09523809523809523,
      "stop": 0.14285714285714285
    },
    {
      "type": "algorithmic",
      "fromColor": [
        184,
        67,
        0,
        255
      ],
      "toColor": [
        213,
        83,
        1,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.14285714285714285,
      "stop": 0.19047619047619047
    },
    {
      "type": "algorithmic",
      "fromColor": [
        213,
        83,
        1,
        255
      ],
      "toColor": [
        225,
        101,
        1,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.19047619047619047,
      "stop": 0.23809523809523808
    },
    {
      "type": "algorithmic",
      "fromColor": [
        225,
        101,
        1,
        255
      ],
      "toColor": [
        233,
        119,
        1,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.23809523809523808,
      "stop": 0.2857142857142857
    },
    {
      "type": "algorithmic",
      "fromColor": [
        233,
        119,
        1,
        255
      ],
      "toColor": [
        242,
        137,
        15,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.2857142857142857,
      "stop": 0.3333333333333333
    },
    {
      "type": "algorithmic",
      "fromColor": [
        242,
        137,
        15,
        255
      ],
      "toColor": [
        249,
        153,
        28,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.3333333333333333,
      "stop": 0.38095238095238093
    },
    {
      "type": "algorithmic",
      "fromColor": [
        249,
        153,
        28,
        255
      ],
      "toColor": [
        253,
        165,
        34,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.38095238095238093,
      "stop": 0.42857142857142855
    },
    {
      "type": "algorithmic",
      "fromColor": [
        253,
        165,
        34,
        255
      ],
      "toColor": [
        252,
        170,
        38,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.42857142857142855,
      "stop": 0.47619047619047616
    },
    {
      "type": "algorithmic",
      "fromColor": [
        252,
        170,
        38,
        255
      ],
      "toColor": [
        249,
        177,
        40,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.47619047619047616,
      "stop": 0.5238095238095237
    },
    {
      "type": "algorithmic",
      "fromColor": [
        249,
        177,
        40,
        255
      ],
      "toColor": [
        248,
        183,
        42,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.5238095238095237,
      "stop": 0.5714285714285714
    },
    {
      "type": "algorithmic",
      "fromColor": [
        248,
        183,
        42,
        255
      ],
      "toColor": [
        233,
        186,
        70,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.5714285714285714,
      "stop": 0.6190476190476191
    },
    {
      "type": "algorithmic",
      "fromColor": [
        233,
        186,
        70,
        255
      ],
      "toColor": [
        204,
        184,
        115,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.6190476190476191,
      "stop": 0.6666666666666666
    },
    {
      "type": "algorithmic",
      "fromColor": [
        204,
        184,
        115,
        255
      ],
      "toColor": [
        171,
        182,
        153,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.6666666666666666,
      "stop": 0.7142857142857142
    },
    {
      "type": "algorithmic",
      "fromColor": [
        171,
        182,
        153,
        255
      ],
      "toColor": [
        138,
        178,
        188,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.7142857142857142,
      "stop": 0.7619047619047619
    },
    {
      "type": "algorithmic",
      "fromColor": [
        138,
        178,
        188,
        255
      ],
      "toColor": [
        122,
        181,
        215,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.7619047619047619,
      "stop": 0.8095238095238095
    },
    {
      "type": "algorithmic",
      "fromColor": [
        122,
        181,
        215,
        255
      ],
      "toColor": [
        155,
        199,
        226,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.8095238095238095,
      "stop": 0.8571428571428571
    },
    {
      "type": "algorithmic",
      "fromColor": [
        155,
        199,
        226,
        255
      ],
      "toColor": [
        190,
        218,
        236,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.8571428571428571,
      "stop": 0.9047619047619047
    },
    {
      "type": "algorithmic",
      "fromColor": [
        190,
        218,
        236,
        255
      ],
      "toColor": [
        223,
        236,
        245,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.9047619047619047,
      "stop": 0.9523809523809523
    },
    {
      "type": "algorithmic",
      "fromColor": [
        223,
        236,
        245,
        255
      ],
      "toColor": [
        248,
        252,
        253,
        255
      ],
      "algorithm": "esriCIELabAlgorithm",
      "start": 0.9523809523809523,
      "stop": 1.0
    }
  ]
};
